import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "ItemConfiguration/Create",
      objinsert
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "ItemConfiguration/Update",
      objupdate
    );
  }
  List() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemConfiguration/List");
  }
  Edit(EditId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemConfiguration/Get?id=" + EditId + ""
    );
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "ItemConfiguration/Delete?id=" + DelID
    );
  }

  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "ItemConfiguration/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }

  ListItemConfigTypes() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ItemConfigurationType/List");
  }
}
export default new Commonservices();
